import styled from "styled-components";
import { Button } from "react-bootstrap";
import { Modal } from "components/shared/Modal/Modal";
import { colors } from "utils";

export const SessionFullModal = ({ open, onClose }) => {
  return (
    <Modal open={open}>
      <Title>This group is full.</Title>
      <Body>
        It looks like this group has reached the limit for students. Please ask
        your teacher for a new code so you can join a different team!
      </Body>
      <StyledButton onClick={onClose}>OK, I'll ask my teacher</StyledButton>
    </Modal>
  );
};

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 16px;
`;

const Body = styled.p`
  font-size: 16px;
  text-align: center;
  margin-bottom: 24px;
  color: #333;
`;

const StyledButton = styled(Button)`
  background-color: ${colors.pink500};
  border: none;
  border-radius: 20px;
  font-size: 14px;
  padding: 10px 24px;

  &:hover,
  &:focus,
  &:active {
    background-color: ${colors.pink500};
    filter: brightness(0.9);
  }
`;
